export default __webpack_public_path__ + "static/media/padel-gold-featured.2bafb779.png";